var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/equipment.c98ca231.png","uri@2x": __webpack_public_path__ + "static/media/equipment.0ce2917a.png","uri@3x": __webpack_public_path__ + "static/media/equipment.22ca8977.png",
    width: 12,
    height: 12
});